import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView, analytics } from '../utils/analytics';
import { getAnalyticsConsent, onAnalyticsConsentChange, ensureRegionDefaultConsent } from '../utils/consent';

export const useAnalytics = () => {
  const location = useLocation();

  // Initialize GA after consent only
  const initializedRef = useRef(false);
  useEffect(() => {
    // Apply region default first (non-EU → granted), then initialize if granted
    ensureRegionDefaultConsent().finally(() => {
      const current = getAnalyticsConsent();
      if (current === 'granted' && !initializedRef.current) {
        // Defer GA to idle/interaction to avoid impacting LCP
        initGA({ defer: true });
        initializedRef.current = true;
      }
    });
    const off = onAnalyticsConsentChange((consent) => {
      if (consent === 'granted' && !initializedRef.current) {
        initGA({ defer: true });
        initializedRef.current = true;
      }
    });
    return () => off();
  }, []);

  // Track page views on route changes
  useEffect(() => {
    if (location.pathname) {
      trackPageView(location.pathname);
    }
  }, [location.pathname]);

  return analytics;
};

export default useAnalytics;
